import { Calendar, RmsNextWorkingDayResponde, IJobsiteSalesAreasResponse, FullSalesArea } from '@cemex-core/cmx-api';
import { createAction, props } from '@ngrx/store';
import { NextWorkingDayResponseV5 } from '@cemex-core/cmx-api/models/next-working-day/next-working-day-res';
import { Plant } from '@cemex-core/cmx-api/models/order-management/plant';

export interface CalendarSlot {
  timestamp: number;
  date: Date;
  initialTime?: string;
  finalTime?: string;
  reactionTime?: number;
  isAfterOrderingHours?: boolean;
  isSameDay?: boolean;
  isSlotEnabled?: boolean;
  type?: string;
}

export interface ShipmentLocationWorkSheet {
  shipmentLocationId: string | number;
  calendarSlots: CalendarSlot[];
  plant?: Plant;
}

export const setActive = createAction(
  '[MOOE/Calendar slot] Set Active Entity',
  props<{ shipmentLocationId: number | string }>(),
);

export const fetch = createAction('[MOOE/Calendar slot] Fetch start', props<{ shipmentLocationId: number | string }>());
export const fetchV2 = createAction(
  '[MOOE/Calendar slot] Fetch V2 start',
  props<{ shipmentLocationId: number | string }>(),
);
export const fetchCalendarsSuccess = createAction(
  '[MOOE/Calendar slot] Fetch Calendars Success',
  props<{ payload: ShipmentLocationWorkSheet }>(),
);
export const fetchFailed = createAction(
  '[MOOE/Calendar slot] Fetch failed',
  props<{ shipmentLocationId: number | string }>(),
);

export const setCutOffResponse = createAction(
  '[MOOE/Calendar slot] Set CutOff',
  props<{ cutOffResponse: RmsNextWorkingDayResponde | NextWorkingDayResponseV5 }>(),
);
export const setCalendarsResponse = createAction(
  '[MOOE/Calendar slot] Set Calendars',
  props<{ calendarsResponse: Calendar }>(),
);

export const setCalendarsV2Response = createAction(
  '[MOOE/Calendar slot] Set Calendars V2',
  props<{ calendarsResponse: Calendar }>(),
);
export const setJobsiteSalesAreasResponse = createAction(
  '[MOOE/Calendar slot] Set Jobsite Sales Areas Response',
  props<{ response: IJobsiteSalesAreasResponse }>(),
);

export const setJobsiteSalesAreasWithoutPOResponse = createAction(
  '[MOOE/Calendar slot] Set Jobsite Sales Areas without PO Response',
  props<{ response: IJobsiteSalesAreasResponse }>(),
);

export const setFullSalesAreasResponse = createAction(
  '[MOOE/Calendar slot] Set Full Sales Areas Response',
  props<{ response: FullSalesArea }>(),
);

export const setPlantResponse = createAction(
  '[MOOE/Shipment Location Worksheets] Set Plant Response',
  props<{ shipmentLocationId: number | string; response: Plant }>(),
);

export const resetShipmentLocationWorkSheet = createAction('[MOOE/Reset State] Reset Full State');

export const ShipmentLocationWorkSheetActions = {
  setActive,
  fetch,
  fetchV2,
  fetchCalendarsSuccess,
  fetchFailed,
  setCalendarsResponse,
  setCalendarsV2Response,
  setCutOffResponse,
  setJobsiteSalesAreasResponse,
  setJobsiteSalesAreasWithoutPOResponse,
  setFullSalesAreasResponse,
  resetShipmentLocationWorkSheet,
  setPlantResponse,
};

export default ShipmentLocationWorkSheetActions;
